const MandaSVG = ({ className }: { className?: string }) => {
    return (
        <svg
            data-testid="manda"
            className={className}
            width="20"
            height="18"
            viewBox="0 0 13000 6000"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="scale(1,-1) translate(0,-6000)">
                <path
                    d="M10238 5601 l-33 -29 -3 -551 c-1 -303 -5 -551 -9 -551 -3 0 -36 24
-72 54 -84 69 -175 121 -271 154 -68 23 -90 26 -235 26 -177 1 -229 -9 -361
-69 -312 -142 -521 -421 -606 -810 -19 -90 -16 -391 5 -485 101 -456 412 -781
811 -851 111 -19 303 -7 401 26 112 37 203 88 273 151 33 30 62 54 65 54 2 0
7 -27 10 -59 6 -72 24 -111 57 -128 18 -9 86 -13 238 -13 226 0 258 6 282 49
7 13 10 506 10 1508 0 1395 -2 1489 -18 1509 -33 41 -52 44 -286 44 l-226 0
-32 -29z m-318 -1457 c30 -9 78 -28 105 -41 59 -30 170 -116 179 -139 3 -9 6
-179 6 -379 l0 -363 -52 -46 c-136 -119 -338 -178 -503 -147 -178 33 -330 172
-388 356 -58 181 -33 407 61 551 76 115 192 197 318 223 65 13 205 6 274 -15z"
                />
                <path
                    d="M1344 4699 c-129 -21 -292 -92 -399 -172 -33 -25 -63 -43 -67 -41 -5
3 -8 30 -8 61 0 49 -4 59 -34 89 l-34 34 -216 0 c-244 0 -267 -5 -292 -65 -22
-53 -21 -1983 1 -2025 30 -59 38 -60 293 -60 l234 0 34 34 34 34 0 681 0 682
73 72 c110 110 228 157 360 143 148 -15 241 -101 284 -263 13 -48 16 -162 20
-691 l5 -633 23 -27 23 -27 236 -3 c257 -3 287 2 306 54 6 15 10 296 10 703
l0 678 49 51 c57 60 136 112 206 138 77 28 224 25 292 -5 59 -26 124 -91 149
-148 46 -107 46 -116 51 -781 l5 -633 23 -27 23 -27 240 -3 241 -3 33 30 33
29 3 654 c3 706 -2 820 -44 965 -38 132 -86 215 -179 308 -63 64 -98 90 -165
122 -116 57 -183 73 -331 80 -206 9 -381 -28 -548 -118 -73 -39 -177 -116
-215 -158 l-19 -21 -71 73 c-111 116 -227 183 -362 212 -75 16 -218 18 -300 4z"
                />
                <path
                    d="M4665 4704 c-349 -51 -659 -325 -789 -694 -82 -234 -90 -522 -22
-765 109 -390 424 -692 790 -756 100 -17 302 -6 391 21 103 32 214 94 285 157
71 65 80 62 80 -30 0 -51 4 -62 29 -88 l29 -29 226 0 226 0 32 29 33 29 0
1017 0 1017 -35 29 -34 29 -214 0 c-277 0 -292 -7 -292 -129 0 -33 -5 -63 -10
-66 -6 -3 -36 16 -68 42 -98 84 -153 114 -287 159 -67 22 -101 27 -210 29 -71
2 -143 1 -160 -1z m435 -560 c84 -25 186 -82 246 -139 l54 -51 0 -357 0 -357
-36 -40 c-115 -127 -348 -202 -533 -171 -267 44 -442 305 -416 621 21 269 182
467 415 510 62 12 204 4 270 -16z"
                />
                <path
                    d="M7434 4701 c-131 -21 -294 -92 -392 -171 -34 -27 -64 -50 -67 -50 -3
0 -5 16 -5 36 0 63 -21 115 -54 135 -28 17 -54 19 -243 19 -143 0 -221 -4
-238 -12 -57 -26 -55 20 -55 -1072 l0 -1005 24 -28 24 -28 233 -3 c163 -2 241
0 261 9 61 25 58 -10 58 740 l0 687 35 35 c55 55 138 106 228 139 69 26 97 31
177 32 85 1 101 -2 152 -27 90 -44 157 -132 190 -249 8 -30 13 -228 17 -676
l6 -634 33 -29 32 -29 233 0 c254 0 262 2 292 60 21 41 22 1317 1 1455 -49
320 -242 554 -531 647 -67 22 -319 33 -411 19z"
                />
                <path
                    d="M11915 4704 c-138 -20 -300 -91 -422 -183 -200 -151 -332 -359 -404
-636 -21 -79 -23 -113 -24 -285 0 -131 5 -215 14 -255 100 -436 372 -742 750
-842 50 -14 104 -18 221 -18 134 0 165 3 230 24 108 33 224 97 290 158 32 29
60 53 64 53 3 0 6 -24 6 -52 0 -62 25 -118 60 -135 32 -16 438 -18 473 -2 13
6 31 23 40 39 16 26 17 113 17 1030 l0 1002 -34 34 -34 34 -216 0 c-244 0
-267 -5 -292 -65 -8 -19 -14 -57 -14 -85 0 -27 -4 -50 -8 -50 -5 0 -19 12 -33
26 -64 69 -187 140 -310 179 -70 22 -106 28 -214 30 -71 2 -143 1 -160 -1z
m435 -560 c79 -23 177 -77 238 -130 l52 -46 0 -372 0 -372 -37 -36 c-129 -124
-342 -189 -520 -160 -193 32 -343 180 -400 392 -23 88 -23 262 0 350 57 211
202 354 397 391 62 11 204 3 270 -17z"
                />
                <path
                    d="M11799 1787 c-9 -7 -21 -22 -27 -34 -17 -30 -17 -1341 -1 -1376 6
-14 22 -30 36 -36 17 -8 225 -11 697 -11 666 0 674 0 700 21 l26 20 0 694 0
694 -26 20 c-26 21 -34 21 -708 21 -520 -1 -685 -4 -697 -13z m1256 -722 l0
-560 -554 -3 c-437 -2 -556 0 -563 10 -9 15 -11 1078 -2 1102 6 15 62 16 563
14 l556 -3 0 -560z"
                />
                <path
                    d="M12200 1071 c0 -143 4 -262 9 -265 9 -6 127 39 149 56 9 8 12 61 12
203 0 142 -3 195 -12 203 -14 11 -136 62 -150 62 -4 0 -8 -117 -8 -259z"
                />
                <path
                    d="M12700 1301 l-65 -27 -3 -205 -2 -205 60 -27 c33 -15 70 -28 83 -30
l22 -2 0 260 c0 223 -2 260 -15 262 -8 1 -44 -11 -80 -26z"
                />
                <path
                    d="M8740 1560 c-35 -35 -25 -92 21 -115 39 -21 56 -19 84 10 29 28 32
70 9 103 -20 29 -85 31 -114 2z"
                />
                <path
                    d="M7977 1443 c-9 -8 -9 -368 0 -376 3 -4 12 -2 20 5 10 8 23 8 52 -1
107 -32 195 62 159 170 -24 73 -71 93 -178 78 -24 -4 -25 -2 -28 64 -3 62 -9
77 -25 60z m174 -172 c23 -24 29 -38 29 -75 0 -85 -77 -131 -147 -87 -32 20
-33 23 -33 85 0 58 3 67 26 85 39 31 89 28 125 -8z"
                />
                <path
                    d="M8250 1318 c0 -7 21 -66 47 -132 l46 -120 -19 -35 c-16 -30 -25 -36
-51 -37 -18 0 -36 -4 -40 -8 -10 -10 17 -26 43 -26 45 0 70 36 133 194 33 85
61 160 61 165 0 6 -6 11 -14 11 -12 0 -53 -90 -80 -178 -12 -37 -28 -21 -57
60 -15 41 -32 85 -38 97 -13 23 -31 28 -31 9z"
                />
                <path
                    d="M9935 1309 c-51 -25 -101 -74 -128 -124 -30 -56 -30 -182 0 -240 47
-89 137 -144 237 -145 81 0 129 17 182 63 70 62 89 106 89 209 0 84 -1 87 -40
144 -57 82 -120 114 -224 114 -55 -1 -87 -6 -116 -21z m185 -97 c94 -47 115
-185 39 -261 -118 -119 -303 2 -254 166 29 97 125 139 215 95z"
                />
                <path
                    d="M10575 1319 c-58 -22 -121 -78 -154 -139 -23 -43 -26 -163 -6 -217
55 -144 235 -210 380 -138 59 28 108 78 103 104 -2 9 -20 24 -41 34 l-37 19
-36 -32 c-65 -56 -123 -65 -189 -27 -79 44 -107 144 -62 221 56 99 163 113
255 34 32 -27 34 -28 69 -13 19 8 37 15 39 15 2 0 4 9 4 19 0 28 -46 79 -94
103 -48 25 -182 34 -231 17z"
                />
                <path
                    d="M11135 1311 c-51 -23 -118 -96 -136 -147 -20 -58 -16 -160 8 -214 58
-129 215 -190 338 -130 25 12 45 26 45 31 0 17 22 9 57 -21 32 -29 64 -37 97
-24 12 4 16 20 16 53 0 41 -3 49 -25 59 l-25 12 0 175 c0 103 -4 184 -10 196
-13 24 -97 28 -106 5 -5 -12 -12 -11 -47 5 -56 25 -158 25 -212 0z m195 -101
c22 -11 44 -29 50 -39 15 -28 13 -193 -2 -213 -7 -9 -29 -26 -48 -37 -102 -61
-224 17 -224 144 0 124 117 199 224 145z"
                />
                <path
                    d="M8740 1098 c0 -186 3 -227 16 -246 32 -46 118 -69 143 -38 19 22 10
87 -14 100 -11 6 -22 12 -25 14 -3 2 -7 90 -10 195 l-5 192 -52 3 -53 3 0
-223z"
                />
                <path
                    d="M8964 1306 c-5 -14 141 -461 159 -483 5 -7 31 -13 57 -13 l47 0 26
73 c14 39 38 109 53 155 15 45 30 82 34 82 4 0 19 -37 35 -82 15 -46 39 -116
53 -156 l25 -73 55 3 55 3 79 234 c43 128 78 242 78 253 0 17 -6 19 -51 16
-33 -2 -55 -8 -60 -18 -5 -8 -28 -78 -53 -155 -24 -76 -48 -141 -54 -143 -6
-2 -33 65 -60 148 -28 84 -54 156 -60 162 -5 5 -26 8 -47 6 l-38 -3 -52 -154
c-28 -85 -56 -156 -62 -158 -6 -2 -31 59 -57 144 -26 81 -49 154 -51 161 -6
17 -104 16 -111 -2z"
                />
            </g>
        </svg>
    );
};

// eslint-disable-next-line import/no-default-export
export default MandaSVG;
